import { API_ENDPOINTS } from '@/constants';
import type { ApiBuilder } from './types';
import type {
  MetricsOutputDTO,
  GetOccupancyMetricsParams,
} from '@/types/agentEvents';

const metricsQuery =
  (url: string) =>
  (params: Record<string, unknown> = {}) => ({
    url,
    params,
  });

/**
 * Agent Personal Events API (performance metrics used in agent dashboard).
 * All endpoints use the AGENT namespace: /agent-events/agent/*
 */
export const agentEventsApi = (builder: ApiBuilder) => ({
  // Agent Performance Metrics — each can be refreshed independently
  getAgentQueueStatusMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_AGENT +
          API_ENDPOINTS.AGENT_EVENTS.QUEUE_STATUS
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAgentAverageWaitTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_AGENT +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_QUEUE_ANSWER_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAgentServiceLevelMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_AGENT +
          API_ENDPOINTS.AGENT_EVENTS.SERVICE_LEVEL
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAgentAverageTalkTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_AGENT +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_HANDLE_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAgentAverageHoldTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_AGENT +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_HOLD_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),
});
